<fikoyt-kart>
      <button nz-button nz-wave
              style="position: absolute;"
              [routerLink]="['/giris']"
              nzType="default"
              nzShape="circle" nzSize="small"><nz-icon nzType="home" /></button>
      <img ngSrc="./simgeler/fikoyt_yazi.png"  
           alt="Site Logo Yazı"
           height="54"
           width="166"
           style="height: unset; width: 166px; box-shadow: none !important;align-self: center;">

      <nz-alert nzMessage="Şifrenizi Sıfırlayın"
                style="text-align: center;"></nz-alert>

      <span nz-typography
            nzType="secondary"
            style=" margin-top: 0.5em;">E-Posta :</span>
      <nz-input-wrapper nzPrefix="📧"
                      nzSize="small">
            <input type="email" autocomplete="email" nz-input />
      </nz-input-wrapper>


      <button nz-button nz-wave 
              nzSize="small"
              nzType="link"
              style="margin-top: 0.5em;">
            ♻️ Sıfırla
      </button>

</fikoyt-kart>